import useEnvironment from 'hooks/store/useEnvironment';
import qs from 'query-string';
import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { openInNewTab } from 'utils/windowUtils';

export interface INavigationOptions {
  openInNewTab?: boolean;
}

export default function useNavigation<T extends object>(pathname: string) {
  const location = useLocation();
  const navigate = useNavigate();
  const { REACT_APP_APP_URL } = useEnvironment();

  const baseUrl = useMemo(() => {
    return REACT_APP_APP_URL.endsWith('/')
      ? REACT_APP_APP_URL.slice(0, REACT_APP_APP_URL.length - 1)
      : REACT_APP_APP_URL;
  }, [REACT_APP_APP_URL]);

  return useCallback(
    (params?: T, options?: INavigationOptions) => {
      const search = qs.stringify(params as { [key: string]: unknown });

      if (options?.openInNewTab) {
        const url = `${baseUrl}${pathname}${search ? `?${search}` : ''}`;
        openInNewTab(url);
      } else {
        navigate({ search: search ? search : undefined, pathname });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location, pathname, baseUrl]
  );
}
